import type { StrictOmit } from '@frontend/duck-tape';
import type { LoaderProps as MLoaderProps } from '@mantine/core';
import { Loader as MLoader } from '@mantine/core';

export type SpinnerProps = StrictOmit<MLoaderProps, 'classNames' | 'color'>;

export const Spinner = ({ ...props }: SpinnerProps) => {
  return <MLoader color="blue.9" {...props} />;
};
